import ListJobPositionsAndRoleMyConfig from './ListJobPositionsAndRoleMyConfig'

export default ListJobPositionsAndRoleMyConfig
